var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "train"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.33398 3.66667H6.66732M4.00065 1V3.66667M2.66732 6.33333L2.00065 7.33333M6.00065 7.33333L5.33398 6.33333M2.00065 1H6.00065C6.36884 1 6.66732 1.29848 6.66732 1.66667V5.66667C6.66732 6.03486 6.36884 6.33333 6.00065 6.33333H2.00065C1.63246 6.33333 1.33398 6.03486 1.33398 5.66667V1.66667C1.33398 1.29848 1.63246 1 2.00065 1Z",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.585d60d9e440f505681d2001f5fe8dd8.svg";
export { ForwardRef as ReactComponent };